import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

/**
 * Toast service.
 *
 * The toast service is based on Material's SnackBar toast.
 *
 * @todo Create 'start' toast: Open toast with loading icon and 'Loading' text.
 * @todo Create 'finish' toast: Replace toast with checkmark and custom text.
 *
 * [documentation](https://material.angular.io/components/snack-bar)
 */
@Injectable({
  providedIn: 'root'
})
export class ToastService {

  /** Default snackbar config. */
  private readonly SNACKBAR_CONFIG: MatSnackBarConfig = { duration: 1500, horizontalPosition: 'right' };

  /** Constructor. */
  constructor(
    private snackBar: MatSnackBar
  ) { }

  /**
   * Open toast.
   *
   * The method is forwarded/binded to Material's SnackBar toast.
   *
   * [documentation](https://material.angular.io/components/snack-bar).
   *
   * @param message The meesage to show in the toast.
   * @param [actionText=null] The message to show as action text.
   * @param [config] SnackBar configuration (See documentation).
   */
  public open(text: string, actionText: string = null, config?: MatSnackBarConfig): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(text, actionText, { ...this.SNACKBAR_CONFIG, ...config });
  }
}
